import { createSelector } from '@reduxjs/toolkit';

export const dashboardSelector = createSelector(
    (state: ReturnType<any>) => state.dashboard,
    (state) => state,
);
